import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixPromoteSeoHeadlessSitemapServiceV1SeoHeadlessSitemapServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/seo-headless-sitemap/v1/list-static-sitemap-pages',
        destPath: '/v1/list-static-sitemap-pages',
      },
    ],
    _: [
      {
        srcPath: '/_api/seo-headless-sitemap/v1/list-sitemap-pages',
        destPath: '/v1/list-sitemap-pages',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/seo-headless-sitemap/v1/list-sitemap-pages',
        destPath: '/v1/list-sitemap-pages',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/v1/list-sitemap-pages',
        destPath: '/v1/list-sitemap-pages',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/seo-headless-sitemap',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_seo_seo-sitemap-entries';

/** Lists sitemap pages for a given item type with optional pagination */
export function listSitemapPages(payload: object): RequestOptionsFactory<any> {
  function __listSitemapPages({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.promote.seo.v1.headless_sitemap_entry',
      method: 'GET' as any,
      methodFqn:
        'wix.promote.seo.headless.sitemap.service.v1.SeoHeadlessSitemapService.ListSitemapPages',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixPromoteSeoHeadlessSitemapServiceV1SeoHeadlessSitemapServiceUrl(
        { protoPath: '/v1/list-sitemap-pages', data: payload, host }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listSitemapPages;
}
